import { render, staticRenderFns } from "./PatientLendingPrograms.vue?vue&type=template&id=205b096d&scoped=true&"
import script from "./PatientLendingPrograms.vue?vue&type=script&lang=js&"
export * from "./PatientLendingPrograms.vue?vue&type=script&lang=js&"
import style0 from "./PatientLendingPrograms.vue?vue&type=style&index=0&id=205b096d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b096d",
  null
  
)

export default component.exports